export function titleCase(str: string) {
  return str?.toLowerCase().replace(/\b(\w)/g, (s) => s.toUpperCase());
}

export function sentenceCase(str: string) {
  return str.replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
}

// Borrowed from https://www.npmjs.com/package/strip-indent,
// which as of version 4 Jest is unable to import due to the
// switch to ESM. The workarounds suggested by Jest did not work.
export function stripIndent(str: string) {
  const indent = minIndent(str);

  if (indent === 0) {
    return str;
  }

  const regex = new RegExp(`^[ \\t]{${indent}}`, "gm");

  return str.replace(regex, "");
}

// Borrowed from https://www.npmjs.com/package/min-indent
export function minIndent(str: string) {
  const match = str.match(/^[ \t]*(?=\S)/gm);

  if (!match) {
    return 0;
  }

  return match.reduce((r, a) => Math.min(r, a.length), Infinity);
}
